/**
 * @desc 获取订阅类型
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, options?: any) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/getEventTypes/${shopCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
